<template>
    <div>
        <dzTab :active.sync="activeTab" :tabs="tabs" :name="$options.name" use-route />
        <slot name="notice" :activeTab="activeTab"></slot>
        <router-view />
    </div>
</template>

<script>
import dzTab from './components/common/dzTab';

export default {
    name: 'ForbiddenWordCheck',
    components: {
        dzTab,
    },
    data() {
        return {
            activeTab: 'checkCenter',
            tabs: [
                {
                    name: '检测中心',
                    tab: 'checkCenter',
                },
                {
                    name: '检测记录',
                    tab: 'checkRecord',
                },
                {
                    name: '管理违禁词',
                    tab: 'manage',
                },
            ],
        };
    },
};
</script>

<style lang="scss"></style>
